import React, { useState, useEffect } from 'react';
import './assets/scss/styles.scss';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { cleanArray, getCurrentLanguage, getImage, linkTo, translate } from '../../assets/js/functions';
import {Helmet} from "react-helmet";
import { base_path, getGroupsMarkers, getMapsMarksByParent } from '../../assets/js/api';
import Proj from 'proj4';

export default function Map(){

    const [data] = useState([])
    const [dataGroup] = useState([])
    const title = translate("Mapa");
    const firstProjection = '+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs ';
    var map = null;


    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://sitna.tracasa.es/api/";
        script.async = true;
        script.onload = () => scriptLoaded();

        document.body.appendChild(script);
    }, [])

    function getNewCoords(coords){
        return Proj(firstProjection, coords)
    }

    function getGeoJsonCoords(item, cord = null){
        if (!cord) return JSON.parse(item)[0].layer_data.features[0].geometry.coordinates
        if (cord === 'lat') return JSON.parse(item)[0].layer_data.features[0].geometry.coordinates[0]
        if (cord === 'lon') return JSON.parse(item)[0].layer_data.features[0].geometry.coordinates[1]
    }

    function scriptLoaded(){
        var SITNA = window.SITNA;
        map = new SITNA.Map("mapa");

        getGroupsMarkers().then(
            group => group.data.result.map(
                mGroup => {
                    getMapsMarksByParent(mGroup.term_id).then((marks) =>
                        marks.data.result.map(
                            mark => getGeoJsonCoords(mark.space_geojson, 'lon') && data.push(mark) && dataGroup.push(mGroup.term)
                        )
                    )
                    .finally(() =>
                        {
                            map.loaded(function () {
                                let currentData = null;
                                let _arr = cleanArray(dataGroup).sort()
                                setTimeout(data.map(
                                    (res, index) => {
                                        if (getCurrentLanguage() === 'es')
                                        currentData = {
                                            "Grupo": dataGroup[index],
                                            "Nombre": res.term,
                                            "__image_200_auto": JSON.parse(res.identify_image) && getImage(JSON.parse(res.identify_image)[0]),
                                            "Ver ficha": 'http://'+window.location.host+'/'+base_path+linkTo("/explore/"+res.term_id)
                                        }
                                        else
                                        currentData = {
                                            "Taldea": dataGroup[index],
                                            "Izena": res.term,
                                            "__image_200_auto": JSON.parse(res.identify_image) && getImage(JSON.parse(res.identify_image)[0]),
                                            "Fitxa ikusi": 'http://'+window.location.host+'/'+base_path+linkTo("/explore/"+res.term_id)
                                        }
                                        map.addMarker(getNewCoords(getGeoJsonCoords(res.space_geojson)), {
                                            group: dataGroup[index],
                                            "cssClass": "tc-marker"+(_arr.indexOf(dataGroup[index])+1),
                                            data: currentData
                                        })
                                    }
                                ), 1000)
                                map.zoomToMarkers();
                            })
                        }
                    )
                    return null
                }
            )
        )

    }


    return (
        <div id="map-testimonios">
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <Breadcrumbs currentSite={title}/>
            <div id="mapa"></div>
        </div>
    )
}
